import {getFormattedDateTime, AttachmentFile, AttachmentTypeCode, toAttachmentType} from "@ots-frontend/ots-data";

export const formatAttachmentSize = (bytes?: number | null): string => {
  if (bytes === undefined || bytes === null) return "Size unavailable";
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 ** 2) return `${(bytes / 1024).toFixed(bytes < 10 * 1024 ? 1 : 0)} KB`;
  return `${(bytes / 1024 ** 2).toFixed(bytes < 10 * 1024 ** 2 ? 1 : 0)} MB`;
};

export const attachmentLabel = (type: AttachmentTypeCode): string =>
  toAttachmentType(type).displayValue.defaultMessage;

export const attachmentDate = (attachment: AttachmentFile): string | undefined => {
  const value = attachment.createDttm ?? attachment.lastModifiedDttm;
  if (value == null) return undefined;
  const date = new Date(value);
  return Number.isNaN(date.valueOf()) ? undefined : getFormattedDateTime(value, false);
};
